var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8714 18.7052L19 7H5L6.12859 18.7052C6.23538 20.0019 7.319 21 8.62016 21H15.3798C16.681 21 17.7646 20.0019 17.8714 18.7052ZM7.20211 9L8.1207 18.5271L8.12185 18.541C8.1432 18.8004 8.35993 19 8.62016 19H15.3798C15.6401 19 15.8568 18.8004 15.8782 18.541L15.8793 18.5271L16.7979 9H7.20211Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2921 3.50017C14.9063 2.61713 14.0252 2 13 2H11C9.97477 2 9.09368 2.61713 8.70795 3.50017L5 3.5C4.44772 3.5 4 3.94772 4 4.5V5.25C4 5.38807 4.11193 5.5 4.25 5.5H19.75C19.8881 5.5 20 5.38807 20 5.25V4.5C20 3.94772 19.5523 3.5 19 3.5L15.2921 3.50017Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.4473114e14221ee477a5284b9c62ac8b.svg";
export { ForwardRef as ReactComponent };